import Cookies from 'universal-cookie';
import axios, { AxiosRequestConfig } from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;

export const fetchWithToken = async (
	endpoint: string,
	data?: unknown,
	method: string = 'GET',
	headers?: any,
	signal?: AbortSignal
) => {
	const cookies = new Cookies();
	const url = `${BASE_URL}${endpoint}`;
	const rawToken = cookies.get('jwt_token');
	const token = rawToken ? `Bearer ${rawToken}` : '';

	const config: AxiosRequestConfig = {
		url,
		method: method as any,
		headers: {
			...headers,
			Authorization: token,
			...(method !== 'GET' ? { 'Content-Type': 'application/json' } : {}),
		},
		data: method !== 'GET' ? data : undefined,
		signal,
		validateStatus: () => true, // <-- fetch-like behavior
	};

	const res = await axios(config);

	return {
		data: res.data,
		status: res.status,
	};
};
